import {
  __,
  el,
  RichText,
  Fragment,
} from '../../common/variables';
import { cl, makeShortcodeString } from '../../common/functions';

const editShortcode = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;

  return el(Fragment, {},
    el(RichText, {
      tagName: 'div',
      className: "glanum-leaflet__shortcode-title",
      value: __('Votre carte sera affichée ici'),
      content: __('Votre carte sera affichée ici'),
    }),
    el(RichText, {
      tagName: 'code',
      className: "glanum-leaflet__shortcode-block",
      value: makeShortcodeString(attributes),
      onChange: (value) => {
        setAttributes({ content: value });
      }
    })
  )
}

export { editShortcode }
